<template>
  <div v-if="$store.getters.logged" class="ms-2 me-2 mt-4">
    <div class="position-absolute ms-1 mt-0">
        <a href="/#/home" class="bi bi-arrow-left-circle-fill fs-2"></a>
    </div>
    <!-- <h1 v-if="students.length > 0 && students[0].nomeEvento" class="text-center mb-4 fw-bold">{{ students[0].nomeEvento }}</h1> -->

    <div class="alert alert-dark position-fixed text-center translate-middle-x top-50 start-50" :class="showInfoBevanda ? '' : 'd-none'">
        <div class="row">
            <div class="col ps-5"><h4><b>{{ this.info_bevanda.nomePiatto }}</b></h4></div>
            <div class="col-1 pe-5"><button type="button" class="btn-close btn-lg opacity-100" @click="showInfoBevanda = false"></button></div>
        </div>
        <div class="row mt-3">
            <div class="col text-start">
                <span>
                    <b>{{ this.info_bevanda.nome }}</b>: {{ this.info_bevanda.note }}
                </span>
            </div>
            <!-- <div class="col text-start">
                <span>
                    {{ this.info_bevanda.note }}
                </span>
            </div> -->
        </div>
    </div>

    <div class="row my-3 align-items-center">
        <div class="col text-end">
            <label>Seleziona Corso:</label>
        </div>
        <div class="col">
            <!-- <label>Seleziona Gruppo:</label> -->
            <select class="form-select rounded-pill" v-model="esameCorso">
                <option v-for="corso in edizioniCorso" 
                :key="corso.Edizione_Corso__c" 
                :value="corso.Edizione_Corso__c"
                >{{ corso.Name }}</option>
            </select>
        </div>
        <div class="col text-end">
            <label>Seleziona Gruppo:</label>
        </div>
        <div class="col">
            <!-- <label>Seleziona Gruppo:</label> -->
            <select class="form-select rounded-pill" v-model="gruppo">
                <option value="" selected></option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
            </select>
        </div>
        <div class="col">
            <button type="button" @click="getSlotsAndPiatti()">Aggiorna</button>
        </div>
        <!-- <div class="col">
            <div class="col">Ordina per: </div>
            <button type="button" @click="elencoStudenti = !elencoStudenti">{{ !elencoStudenti ? 'Studenti' : 'Tavoli' }}</button>
        </div> -->
    </div>
    <div v-if="gruppo == ''"><button :class="{'bg-secondary bg-opacity-25': esameCorso == ''}" @click="getEtichette()" :disabled="esameCorso == ''">Etichette</button></div>

    <table v-if="students.length" class="table table-striped table-bordered table-responsive table-nowrap h-100">
      <thead class="sticky-top bgAlma text-white">
        <tr>
          <th class="" @click="sortByNum"># <i v-if="elencoStudenti" class="bi bi-caret-up-fill"></i></th>
          <th class="">Nome e Cognome </th>
          <th class="" @click="sortByTav">Tav <i v-if="!elencoStudenti" class="bi bi-caret-up-fill"></i></th>
          <th v-for="(p, index) in students[0].Piatti" :key="index">
              <span>Piatto n.{{ index+1 }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(student, index) in students" :key="index">
          <td>{{ student.numerazioneAllievo }}</td>
          <td>{{ student.Candidato }}</td>
          <td>{{ student.tavolo }}</td>
          <td class="h-100 align-top" v-for="(piatto, piattoIndex) in student.Piatti" :key="piattoIndex">
              <div class="d-flex flex-row h-100">
                  <div class="w-100 h-100">
                      <div >
                          <div><span><b>{{ piatto.Tipo_Piatto__c }}</b>:</span></div>
                          <span><i>"{{ piatto.Name }}"</i></span>

                          <div class="mt-2" v-if="piatto.Accompagnamento_bevanda__c">
                            <span><b>{{ piatto.Tipo_bevanda__c }}</b>: {{ piatto.Nome_bevanda__c }} </span>
                            <!-- <span v-if="piatto.Note_bevanda__c" @click="showBevanda(piatto)" class="bi bi-info-circle fs-6 text-danger "></span> -->
                          </div>
                          <div class="mb-1" v-if="piatto.Accompagnamento_bevanda__c">
                            <span><b>Note:</b> {{ piatto.Note_bevanda__c }} </span>
                          </div>
                      </div>
                      <!-- <div class="">
                          <button style="width: 10vw" class="mx-auto align-bottom" :class="{'btn-warning' : piatto.Stato__c != 'Non Uscito'}"
                            :disabled="piatto.Stato__c == 'Valutato' || !isExamToday"
                            @click="selezionaPiatto(piatto, student.tavolo)"
                          >
                            {{ piatto.Stato__c == 'Non Uscito' ? 'Conferma' : 'Confermato' }}
                          </button>
                      </div> -->
                  </div>
                  <div class="row ms-2 me-1 flex-shrink-1">
                    <span class="jumbotron align-items-top text-center"><i>{{ piatto.Ordine_di_uscita__c ? '#'+piatto.Ordine_di_uscita__c : '' }}</i></span>

                    <button v-if="isExamToday" style="width: 10vw" class="mx-auto align-self-end" :class="{'btn-warning' : piatto.Stato__c != 'Non Uscito'}"
                        :disabled="piatto.Stato__c == 'Valutato'"
                        @click="selezionaPiatto(piatto, student.tavolo)"
                      >
                        {{ piatto.Stato__c == 'Non Uscito' ? 'Conferma' : 'Confermato' }}
                      </button>
                  </div>
              </div>
          </td>
        </tr>
      </tbody>
    </table>
    <modal :show="showConferma" :title="titleModal" :buttons="buttons" @click="manageModal($event)">
        <p>{{ piattoConferma.Tipo_Piatto__c }}: <i>"{{ piattoConferma.Name }}"</i></p>
    </modal>
  </div>
</template>

<script>
import modal from "../components/modal.vue";

export default {
  name: "Servizio",
  components: {
      modal,
  },
  data() {
    return {
      elencoStudenti: true,
      gruppo: '',
      showConferma: false,
      piattoConferma: {},
      tavoloConferma: '',
      titleModal: '',
      students: [],
      allPiatti: new Map(),
      showInfoBevanda: false,
      info_bevanda: {},
      examDate: null,
      edizioniCorso: [],
      esameCorso: '',
      sortDirection:'ask'
    };
  },
  async mounted () {
    // this.students.sort((a, b) => a.numerazioneAllievo - b.numerazioneAllievo);
    this.edizioniCorso = await this.$store.dispatch('getCorsiVisibili');
    console.log('location: ',document.location)
  },
  computed: {
      buttons() {
          return ["Conferma", "Annulla"];
      },
      isExamToday() {
        if(this.examDate) {
          const today = new Date();
          console.log(this.examDate, today);
          return this.examDate.getDate() === today.getDate() && this.examDate.getMonth() === today.getMonth() && this.examDate.getFullYear() === today.getFullYear();
        }

        return false;
      },
      nomeEdizione() {
        var edCorso = this.edizioniCorso.find( c => c.Edizione_Corso__c == this.esameCorso)
        return edCorso ? edCorso.Name : ''
      }
  },
  methods: {
    getSlotsAndPiatti() {
        console.log('getSlotsAndPiatti');
        this.students = [];
        this.$store.dispatch("getSlots", {gruppo: this.gruppo, isServizio: true, edCorso: this.esameCorso})
        .then( resp => {
            this.allPiatti = new Map()
            console.log(resp);

            for(let slot in resp){
                for(let student of resp[slot]){
                    this.students.push(student);
                    for(let piatto of student.Piatti){
                        if(this.allPiatti.has(student.tavolo)) this.allPiatti.get(student.tavolo).push(piatto)
                        else this.allPiatti.set(student.tavolo, [piatto])
                    }
                }
            }

            if(this.students && this.students[0])
              this.examDate = this.students[0].dataEsame ? new Date(this.students[0].dataEsame) : null;

            if(this.elencoStudenti) this.sortByNum();
            else this.sortByTav();
            console.log(this.students)

            if(this.students && this.students[0] && this.students[0].nomeEvento){
              this.$store.commit('SET_NOME_EVENTO', this.students[0].nomeEvento)
            }
        })
    },
    numUltimoPiattoTav(tavolo) {
        return this.allPiatti.get(tavolo).filter(p => p.Ordine_di_uscita__c != null).length
    },
    selezionaPiatto(piatto, tavolo) {
      console.log('piatto e tavolo', piatto, tavolo)
      console.log(this.numUltimoPiattoTav(tavolo))
      if(piatto.Stato__c == 'Non Uscito' || piatto.Ordine_di_uscita__c == this.numUltimoPiattoTav(tavolo)) {
          console.log('allPiatti', this.allPiatti);
          this.showConferma = true;
          this.piattoConferma = piatto;
          this.tavoloConferma = tavolo
        
          if(piatto.Stato__c == 'Non Uscito') this.titleModal = 'Conferma l\'uscita del piatto'
          if(piatto.Stato__c == 'Uscito') this.titleModal = 'Rimetti in coda il piatto'
      }
    },
    manageModal(e) {
        console.log(e)

        var button = this.buttons[e]
        if(button == 'Conferma') {

            this.piattoConferma.Stato__c = this.piattoConferma.Stato__c == 'Non Uscito' ? 'Uscito' : 'Non Uscito';

            this.piattoConferma.Ordine_di_uscita__c = !this.piattoConferma.Ordine_di_uscita__c ? (this.numUltimoPiattoTav(this.tavoloConferma)+1) : null
                
            this.piattoConferma.Data_Ora_Uscita_Piatto__c = !this.piattoConferma.Data_Ora_Uscita_Piatto__c ? Date.now() : null

            console.log('piattoConferma',this.piattoConferma);
            this.$store.dispatch('updateStatoPiatto', this.piattoConferma)
            .then( resp => {
                console.log(resp);
                this.getSlotsAndPiatti();
            })
        }

        this.showConferma = false
    },
    sortByNum() {
      this.students.sort((a, b) => a.numerazioneAllievo - b.numerazioneAllievo);
      this.elencoStudenti = true;
    },
    // sortByTav() {
    //   this.students.sort((a, b) => a.tavolo - b.tavolo);
    //   this.elencoStudenti = false;
    // },
    sortByTav() {
    if (this.sortDirection === 'asc') {
      this.students.sort((a, b) => a.tavolo - b.tavolo);
      this.sortDirection = 'desc';
    } else {
      this.students.sort((a, b) => b.tavolo - a.tavolo);
      this.sortDirection = 'asc';
    }
    this.elencoStudenti = false;
    },
    showBevanda(piatto) {
      this.info_bevanda = {
        nome: piatto.Nome_bevanda__c,
        note: piatto.Note_bevanda__c,
        nomePiatto: piatto.Name
      }

      this.showInfoBevanda = true
      console.log(this.info_bevanda)
    },
    getEtichette() {
      this.$store.dispatch('stampaEtichetteEsame', { idEdCorso: this.esameCorso, nomeEdCorso: this.nomeEdizione })
    }
  },
};
</script>